// Application Constants for JavaScript
export const APP_CONSTANTS = {
    // Map and UI settings
    MAP: {
        DEFAULT_ZOOM: 14,
        INFO_WINDOW_MAX_HEIGHT: 300,
        INFO_WINDOW_MAX_WIDTH: 350,
        LISTING_IMAGE_HEIGHT: 120,
        LISTING_CARD_WIDTH: 300,
        CUSTOM_PIN_URL: '/images/custom-pin.png'
    },

    // Media and Images
    MEDIA: {
        DEFAULT_LISTING_PLACEHOLDER: '/images/placeholders/indoor.png'
    },

    // Colors and Styling
    COLORS: {
        BRAND_PRIMARY: '#ff8551',
        BRAND_SECONDARY: '#f76164',
        BRAND_ACCENT: '#4252b2',
        STROKE_COLOR: '#ff8551',
        FILL_COLOR: '#ff8551',
        FILL_OPACITY: 0.35
    },

    // UI Timing and Animation
    UI: {
        POPUP_REMOVAL_DELAY: 160,
        MAGNIFICPOPUP_DISABLE_ON: 700,
        CAROUSEL_AUTOPLAY_SPEED: 2000,
        CAROUSEL_AUTOPLAY_SPEED_SLOW: 4000,
        HOW_IT_WORKS_AUTO_ADVANCE: 3500,
        HOW_IT_WORKS_PAUSE_DURATION: 3000,
        CALENDAR_TOTAL_CELLS: 42 // 6 weeks * 7 days
    },

    // Calculator Data
    CALCULATOR: {
        STORAGE_TYPES: [
            'Closet', 'Wardrobe', 'Garden shed', 'Loft', 'Half garage',
            'Single car garage', 'Double garage', 'Spare room', 'Basement',
            'Front and Backyard', 'Parking space'
        ],
        STORAGE_IMAGES: [
            '/images/spaces/storage-room.jpg',
            '/images/spaces/storage-room.jpg',
            '/images/spaces/shed.jpg',
            '/images/spaces/attic.jpg',
            '/images/spaces/garage.jpg',
            '/images/spaces/garage.jpg',
            '/images/spaces/garage.jpg',
            '/images/spaces/storage-room.jpg',
            '/images/spaces/storage-room.jpg',
            '/images/spaces/yard.jpg',
            '/images/spaces/carport.jpg'
        ],
        SIZES: [
            '3', '4-5', '4', '8-12', '8-10', '16-18', '> 30', 
            '18', '18', '14-16', '14'
        ],
        PRICE_ESTIMATES: [
            '10-15', '10-15', '15-20', '20-25', '20-25', '45-60', 
            '70-90', '45-60', '45-60', '15-20', '40-60'
        ]
    }
};

export default APP_CONSTANTS;
